import { Component, OnInit, ViewEncapsulation, AfterViewInit, Input } from '@angular/core';
import { Helpers } from '../../helpers';
import { Router } from '@angular/router';

declare let mLayout: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input()
  currentRoute: any;

  currentUser: any;
  constructor(private _router: Router) {}
  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
    console.log(this.currentUser.type)
  }
  ngAfterViewInit() {
    mLayout.initHeader();
  }
  logout(): void {
    // clear token remove user from local storage
    localStorage.removeItem('currentUser');
    localStorage.clear();
    this._router.navigate(['/login']);
  }
  dashboard(): void {
    this._router.navigate(['/index']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts